import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '@appEnvironments/environment';
import { GUID_ } from '@appShared/guids';

@Injectable({
   providedIn: 'root'
})
export class CryptoService {
   private secretKey = (environment as any)[GUID_.C7F2A8E14B9D4E6FA3015D8B62C9E47A] as string;

   encrypt(value: string): string {
      return CryptoJS.AES.encrypt(value, this.secretKey).toString();
   }

   decrypt(textToDecrypt: string): string {
      const bytes = CryptoJS.AES.decrypt(textToDecrypt, this.secretKey);
      return bytes.toString(CryptoJS.enc.Utf8);
   }
}
